<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-0 mt-4 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="id"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
    >
      <div
        slot="codigo_queja"
        class="title-size font-bold text-gray-500 text-left"
      >
        Código queja
      </div>
      <div
        slot="entidad_cod"
        class="title-size font-bold text-gray-500 text-left"
      >
        Entidad
      </div>
      <div slot="motivo" class="title-size font-bold text-gray-500 text-left">
        Motivo de queja
      </div>
      <!-- <div slot="creation_date" class="title-size font-bold text-gray-500 text-left">
        Fecha de creación
      </div> -->

      <!-- Custom rendering for type_complaint_name column -->
      <template slot="type_complaint_name" slot-scope="text, record">
        <ComplaintTypeLabel :label="record.type_complaint_name" />
      </template>

      <div
        slot="type_complaint_name"
        class="title-size font-bold text-gray-500"
      >
        Tipo de queja
      </div>

      <!-- Custom rendering for estado_cod column -->
      <template slot="estado_cod" slot-scope="text, record">
        <ComplaintAgilizaStatusLabel :status="record.estado_cod" />
      </template>

      <div
        slot="estado_cod"
        class="title-size font-bold text-gray-500 text-center"
      >
        Estado
      </div>
      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div
        slot="actions"
        slot-scope="text, record"
        class="flex space-x-2 justify-center"
      >
        <!-- Botón Ver -->
        <button
          class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
          @click="goToComplaintDetail(record)"
        >
          <a-icon
            type="eye"
            theme="twoTone"
            two-tone-color="#3366cc"
            :style="{ fontSize: '20px' }"
            class="transition-all group-hover:text-white group-hover:two-tone-color-white"
          />
        </button>

        <template v-if="record.estado_cod === STATE_CF_PENDING_ACTION">
          <!-- Botón Editar - Gestion pendiente -->
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="redirectAcceptReject(record)"
          >
            <a-icon
              type="edit"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
        <template
          v-if="record.estado_cod === STATE_CF_PROPOSAL_SUPERVISED_ENTITY"
        >
          <!-- Botón Editar - Contrapropuesta entidad vigilada -->
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="redirectProposalAgiliza(record)"
          >
            <a-icon
              type="edit"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
        <template
          v-if="record.estado_cod === STATE_CF_CLOSED_PROPOSAL_ACCEPTED"
        >
          <!-- Botón Editar - Cerrada – contrapropuesta aceptada -> Reportar incumplimiento -->
          <button
            class="group flex items-center px-3 py-2 border border-blue-600 rounded-md text-xs text-blue-600 hover:bg-blue-300 transition-all"
            @click="reportNonCompliance(record)"
          >
            <a-icon
              type="exclamation-circle"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '20px' }"
              class="transition-all group-hover:text-white group-hover:two-tone-color-white"
            />
          </button>
        </template>
      </div>
    </a-table>
  </div>
</template>

<script>
import ComplaintAgilizaStatusLabel from "@/feature/shared/presentation/partials/ComplaintAgilizaStatusLabel.vue";
import ComplaintTypeLabel from "@/feature/customer/complaint/presentation/partials/ComplaintTypeLabel.vue";
import {
  STATE_CF_CLOSED_PROPOSAL_ACCEPTED,
  STATE_CF_PENDING_ACTION,
  STATE_CF_PROPOSAL_SUPERVISED_ENTITY,
} from "@/core/utils/constants";
const columns = [
  {
    slots: { title: "codigo_queja" },
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    width: 160,
  },
  {
    slots: { title: "entidad_cod" },
    dataIndex: "entidad_cod",
    key: "entidad_cod",
    width: 180,
  },
  {
    slots: { title: "motivo" },
    dataIndex: "motivo",
    key: "motivo",
    width: 300,
  },
  {
    slots: { title: "type_complaint_name" },
    dataIndex: "type_complaint_name",
    key: "type_complaint_name",
    scopedSlots: { customRender: "type_complaint_name" }, // Enable custom rendering
    width: 140,
  },
  {
    slots: { title: "estado_cod" },
    dataIndex: "estado_cod",
    key: "estado_cod",
    scopedSlots: { customRender: "estado_cod" }, // Enable custom rendering
    width: 150,
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    align: "center",
    width: 100,
  },
];

export default {
  components: {
    ComplaintAgilizaStatusLabel,
    ComplaintTypeLabel,
  },
  props: ["dataSource"],
  data() {
    return {
      columns,
      STATE_CF_CLOSED_PROPOSAL_ACCEPTED,
      STATE_CF_PENDING_ACTION,
      STATE_CF_PROPOSAL_SUPERVISED_ENTITY,
    };
  },
  methods: {     
    redirectProposalAgiliza(record) {
      this.$router.push(
        `/customer/complaint/tracking/detail/${record.codigo_queja}?type=agiliza&action=contrapropuesta`
      );
    },
    redirectAcceptReject(record) {
      this.$router.push(
        `/customer/complaint-agiliza/confirm/${record.codigo_queja}`
      );
    },
    async reportNonCompliance(record) {
      this.$emit("getReportNonCompliance", record);
    },
    async goToComplaintDetail(record) {
      this.$emit("goToComplaintDetail", record);
    },
  },
};
</script>
